import os from '@edu-fe/os'
import axios from 'axios'
import * as get from '@ccforeverd/tool-get'

/**
 * 获取 wpsSid
 * @return {Promise} wpsSid
 */
export default async function getWpsSid () {
  // 链接上挂的 wpsSid
  const data = get.query()
  if (data.wpsSid) {
    return data.wpsSid
  }

  console.log('--os.type: ' + os.type)
  // 正常获取 wpsSid
  switch (os.type) {
    case 'ali':
    case 'browser':
    case 'weixin':
      const { data: {
        code: code1,
        data: wpsSidFromAPI
      } } = await axios.get('http://localhost:9127/wpsSid')

      // 跨域失败, 未登录
      if (code1 !== 1) {
        return ''
      }

      const { data: {
        code: code2
      } } = await axios.get('http://localhost:9127/user_info', {
        params: { wpsSid: wpsSidFromAPI }
      })

      // 登录过期
      if (code2 !== 1) {
        return ''
      }

      return wpsSidFromAPI
    case 'app':
      const wpsSidFromSDK = await os.sdk.user.get()

      if (!wpsSidFromSDK && os.sdk.user.getToken) {
        const loginToken = await os.sdk.user.getToken()

        return loginToken && `loginToken=${loginToken}`
      }

      return wpsSidFromSDK
    default:
      return ''
  }
}
